import { Observable } from "rxjs";
import "rxjs-compat";
import { ofType, combineEpics } from "redux-observable";
import { switchMap, map } from "rxjs/operators";
import experimentResource from "@ane/exp-data/lib/resources/ExperimentResources";
import DetailsActions from "./DetailsActions.js";
import DetailsActionTypes from "./DetailsActionTypes.js";
import { getAsyncWrapperFromRestResult } from "@ane/core/lib/services/RestServiceBase";
const fetchExperimentDetailEpic = (action$) => {
  return action$.pipe(
    ofType(DetailsActionTypes.FETCH_STATUS),
    switchMap((value) => {
      const experimentIds = value.payload;
      console.log("experimentIds:", experimentIds);
      if (!experimentIds.length)
        return Observable.empty();
      return Observable.forkJoin(experimentIds.map((id) => experimentResource.getExperiment(id))).pipe(
        map((data) => {
          let finalData = {};
          data.forEach((d, id) => {
            finalData[experimentIds[id]] = getAsyncWrapperFromRestResult(d);
          });
          return DetailsActions.updateStatusData(finalData);
        })
      );
    })
  );
};
const experimentDetailsEpics = combineEpics(fetchExperimentDetailEpic);
export {
  experimentDetailsEpics,
  fetchExperimentDetailEpic
};
//# sourceMappingURL=ExperimentDetailsEpic.js.map
